import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=d48c7ee4&scoped=true&"
var script = {}
import style0 from "./Admin.vue?vue&type=style&index=0&id=d48c7ee4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48c7ee4",
  null
  
)

export default component.exports